//@flow
/* Package JSON Import will be here */
import axios from "axios";
/* Package JSON Import will be here */

/* Project Import will be here */
import { loadState } from "app/localStorage";
import { dispatchInstance } from "reducers/common/appSettings";
import { handleNoAppData, handleAppForceLogout } from "reducers/common";
/* Project Import will be here */

/* Const,Let & Var will be here */
export const authTokenKey = "user-key";
let isForceLogoutApp = false;
/* Const,Let & Var will be here */

/* Generic Request model */
export type IRequest = {
  subUrl: string,
  method?: string,
  data?: object,
  params?: object,
  headers?: object
};

/* Generic HTTP Get method */
export const get = (request, needToken = true) => {
  return commonFetch({
    method: "get",
    ...request
  });
};

/* Generic HTTP Post method */
export const post = (request, needToken = true) => {
  return commonFetch({
    method: "post",
    needToken,
    ...request
  });
};

/* Generic AXIOS method to make HTTP request */
const commonFetch = (request: IRequest) => {
  /* Spread the request object */
  const { subUrl, method, needToken, data = {}, params, headers = {} } = request;

  /* Get all the local state */
  const state = loadState();

  /* Check for token availability*/
  if (state && (!needToken || (state && state.localStore && state.localStore.token) || ([authTokenKey] in headers))) {
    const commonRequestHeaders = getCommonRequestHeaders();
    const url = `${window.serviceApiUrl}${subUrl}`;

    return axios({
      method,
      url,
      data,
      headers: { ...commonRequestHeaders, ...headers },
      params
    })
      .then(response => {
        if (checkResponseStatus(response)) {
          return Promise.resolve(response);
        }
        else {
          if (response.data && response.data.isForceLogout && !isForceLogoutApp && dispatchInstance !== null) {
            /* True the isForceLogoutApp variable to break all the tasks */
            isForceLogoutApp = true;

            /* Show alert and redirect to login page */
            dispatchInstance(handleAppForceLogout(response.data.Code));

            /* After 1.5min change the variable value to false */
            setTimeout(() => { isForceLogoutApp = false }, 1500);
          }
          else {
            return Promise.reject(response);
          }
        }
      });
  }
  else if (!isForceLogoutApp) {
    /* If - Reload the page when no app data available after login with message */
    /* Else - Reload the page when no app data available before login */
    if (dispatchInstance !== null)
      dispatchInstance(handleNoAppData());
    else
      window.location = window.location.origin;
  }
};

/* Check Success or Fail HTTP request */
const checkResponseStatus = (response) => {
  if (response && response.data && response.data.Status && response.data.Status !== "0")
    return true;
  else
    return false;
};

/* Get common request header to make HTTP request */
const getCommonRequestHeaders = () => {
  const state = loadState();
  let token = null;

  /* Get token from local storage */
  if (state && state.localStore && state.localStore.token)
    token = state.localStore.token;

  return {
    "Content-Type": "application/json",
    [authTokenKey]: token,
    "dist-id": state.localStore.selectedWholesaler !== null ? state.localStore.selectedWholesaler.dId : ""
  };
};

/* Get token from state */
export const getAnyTokenFromState = state => {
  return {
    [authTokenKey]: state.localStore.token || state.session.token
  };
};